import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from '../../../../shared/confirmation-modal/confirmation-modal.component';


export interface ActionMenuItem {
  id: string;
  type: 'action' | 'group';
  label: string;
  icon?: string;
  children?: ActionMenuItem[];
  [key: string]: any;
}

/**
 * Menu-group-button - a button, with optional grouping.
 * Items can be grouped two levels for a drop-down menu with more options.
 * not a recursive component because of https://github.com/angular/components/issues/26243 (no accessibility)
 */
@Component({
    selector: 'app-menu-group-button',
             imports: [
               MatButton,
               MatIcon,
               TranslateModule,
               MatMenuItem,
               MatMenu,
               MatMenuTrigger,
               MatIconButton
             ],
    templateUrl: './menu-group-button.component.html',
    styleUrl: './menu-group-button.component.scss'
})
export class MenuGroupButtonComponent {
  private readonly dialog: MatDialog = inject(MatDialog);

  @Input() item: ActionMenuItem;
  @Input() disabled?: boolean = false;
  @Input() isAgent?: boolean = false;
  @Input() readonly?: boolean = false;
  @Output() itemClick = new EventEmitter<ActionMenuItem>()

  itemClicked(item: ActionMenuItem) {
    if (this.item?.operation_steps?.length > 1 && this.item?.operation_steps[1]?.operation_step_type === 'edit_object' && this.isAgent) {
      const dialog = this.dialog.open(ConfirmationModalComponent, {
        data: {
          cancelButtonText: 'TRANS__AGENT__CHANGE__WARNING_CANCEL',
          confirmButtonText: 'TRANS__AGENT__CHANGE__WARNING_CONFIRM',
          content: 'TRANS__AGENT__CHANGE__WARNING__CONTENT',
          hideDontShowAgain: true,
          title: 'TRANS__AGENT__CHANGE__WARNING__TITLE',
        }
      });

      dialog.afterClosed().subscribe(confirmed => {
        if (confirmed) {
          this.itemClick.emit(item);
        }
      });
    }
    else {
      this.itemClick.emit(item);
    }
  }
}
